import { render, staticRenderFns } from "./vehicle_reallocation.vue?vue&type=template&id=1297824a&scoped=true"
import script from "./vehicle_reallocation.vue?vue&type=script&lang=js"
export * from "./vehicle_reallocation.vue?vue&type=script&lang=js"
import style0 from "./vehicle_reallocation.vue?vue&type=style&index=0&id=1297824a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1297824a",
  null
  
)

export default component.exports